const styles = {
  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-16 py-10",

  heroHeadText:
    "font-black text-white font-syne lg:text-[100px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[98px] mt-2",
  heroHeadTexts:
    "font-black  font-syne lg:text-[80px] sm:text-[60px] xs:text-[50px] text-[40px] lg:leading-[80px] mt-2",
  heroSubText:
    "text-[#dfd9ff] font-medium font-syne lg:text-[24px] sm:text-[20px] xs:text-[18px] text-[16px] lg:leading-[40px]",

  sectionHeadText:
    "text-white font-black font-syne md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
  sectionSubText:
    "sm:text-[18px] text-[14px] font-syne text-secondary uppercase tracking-wider",
};

export { styles };
